import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black text-white p-6">
      <div className="max-w-md w-full rounded-sm border border-primary/40 bg-black/90 p-8 space-y-6 text-center" data-testid="payment-cancel-panel">
        <XCircle className="h-10 w-10 mx-auto text-secondary" />
        <p className="font-mono text-[10px] tracking-[0.3em] text-secondary">// SINAL INTERROMPIDO</p>
        <h2 className="font-display font-black text-3xl tracking-tighter">Compra cancelada</h2>
        <p className="text-sm text-muted-foreground">Nada foi cobrado. Sua nave atual segue no hangar.</p>
        <button
          onClick={() => nav("/pilot?openShop=1")}
          data-testid="payment-cancel-back"
          className="w-full rounded-sm bg-primary text-primary-foreground hover:bg-primary/90 font-mono tracking-widest text-xs px-5 py-3"
        >
          VOLTAR À LOJA
        </button>
      </div>
    </div>
  );
}
